import Modal, {ModalBody, ModalFooter, ModalHeader, ModalTitle} from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button/new";
import React from "react";
import {Appearance} from "@atlaskit/modal-dialog/types";

export const ConfirmDialog = ({confirmMsg, confirmTitle, confirmBtnText, cancelBtnText, appearance, onConfirm, onCancel}: {
    confirmMsg?: string,
    confirmTitle?: string,
    confirmBtnText?: string,
    cancelBtnText?: string,
    appearance?: Appearance,
    onConfirm: () => Promise<void>,
    onCancel: () => void,
}) => {
    const [isConfirmBtnLoading, setIsConfirmBtnLoading] = React.useState<boolean>(false);

    const handleConfirm = async () => {
        setIsConfirmBtnLoading(true);
        await onConfirm();
        setIsConfirmBtnLoading(false);
    }

    return <Modal onClose={onCancel}>
        <ModalHeader>
            <ModalTitle appearance={appearance ?? "warning"}>
                {confirmTitle ?? "Please Confirm"}
            </ModalTitle>
        </ModalHeader>
        <ModalBody>
            <p>{confirmMsg}</p>
        </ModalBody>
        <ModalFooter>
            <Button appearance="subtle" onClick={onCancel}>
                {cancelBtnText ?? "No"}
            </Button>
            <Button appearance={appearance ?? "warning"} onClick={handleConfirm} isLoading={isConfirmBtnLoading} autoFocus>
                {confirmBtnText ?? "Yes"}
            </Button>
        </ModalFooter>
    </Modal>
}
